import {
  Alert,
  Box,
  CircularProgress,
  Typography,
  lighten,
  styled,
} from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useStartEsignFlow } from "../../../hooks";

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  marginLeft: "32px",
  marginRight: "4px",
}));

const StyledArrowForwardIosRoundedIcon = styled(ArrowForwardIosRoundedIcon)(
  ({ theme }) => ({
    color: theme.palette.primary.dark,
  })
);

const StyledAlert = styled(Alert)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "sticky",
  alignSelf: "center",
  width: "100%",
  margin: "16px 0px",
  backgroundColor: "#E8E5F5",
  "&:hover": {
    backgroundColor: lighten(theme.palette.primary.main, 0.8),
    cursor: "pointer",
  },
  "& .MuiAlert-message": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "4px",
  },
  "& .MuiAlert-icon": {
    color: theme.palette.primary.main,
  },
}));

const InfoContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
}));

const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.text.black,
}));

export const PendingFeaAuthAlert: React.FC = () => {
  const {
    startEsignFlowMutation: { mutate: startEsignFlow },
    isStartingEsignFlow,
  } = useStartEsignFlow();
  return (
    <StyledAlert
      severity="info"
      onClick={() => startEsignFlow({ providerName: 'esign' })}
      action={
        isStartingEsignFlow ? (
          <StyledCircularProgress size={24} />
        ) : (
          <StyledArrowForwardIosRoundedIcon />
        )
      }
    >
      <InfoContainer>
        <Title>Firma electrónica pendiente</Title>
        <InfoText>
          Este proceso se hace solo una vez para poder emitir recetas
        </InfoText>
      </InfoContainer>
    </StyledAlert>
  );
};
